import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getItems = createAsyncThunk(
  "orders",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getOrder = createAsyncThunk(
  "order",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/${params.id}/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const refreshOrderInList = createAsyncThunk(
  "orders/refreshOrderInList",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/${params.id}/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const updateOrderDriver = createAsyncThunk(
  "updateOrderDriver",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const resetOrders = createAsyncThunk(
  "resetOrders",
  async (params, { rejectWithValue }) => {
    return;
  }
);

export const updateOrderStatus = createAsyncThunk(
  "updateOrderStatus",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getOrderItems = createAsyncThunk(
  "orderItems",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL}/orderitems/`, {
        params,
      });
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const updateOrderPaymentType = createAsyncThunk(
  "updateOrderPaymentType",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const calculateOrder = createAsyncThunk(
  "calculateOrder",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/calculate/`,
        networkParams,
        config
      );
      return { ...data, id };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const postOrder = createAsyncThunk(
  "postOrder",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const updateGrandTotal = createAsyncThunk(
  "updateGrandTotal",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchCustomerNote = createAsyncThunk(
  "patch_customer_note",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchOrder = createAsyncThunk(
  "updateOrder",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchOrderWithNoRedux = createAsyncThunk(
  "updateOrderNoRedux",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const patchOrderItems = createAsyncThunk(
  "updateOrderItems",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params.id}/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchOrderPromotionCode = createAsyncThunk(
  "update_order_promotionCode",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/orders/${params?.id}/`,
        {
          promo_code: params?.promo_code?.id ? params?.promo_code?.id : null,
        },
        config
      );
      return {
        ...data,
        discount: params?.discount,
      };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getOrderRooms = createAsyncThunk(
  "get_order_rooms",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/order_rooms/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const getRoomOrders = createAsyncThunk(
  "get_order_room_orders",
  async ({ id, ...params }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/order_rooms/${id}/orders/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const reportToMetric = createAsyncThunk(
  "sync_with_metric",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/orders/report_to_metrc/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const postOrderRoom = createAsyncThunk(
  "post_order_room",
  async ({ id, ...params }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/order_rooms/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const patchOrderRoom = createAsyncThunk(
  "patch_order_room",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/order_rooms/${params?.id}/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
export const deleteOrderRoom = createAsyncThunk(
  "delete_order_room",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/order_rooms/${params.id}/`,
        params,
        config
      );
      return {
        data,
        id: params?.id,
      };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const getPatientsLasOrder = createAsyncThunk(
  "get_patients_last_order",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${params?.id}/last-order-reorder/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const getReorder = createAsyncThunk(
  "get_reorder",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/${params?.id}/reorder/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const getDriverSuggestions = createAsyncThunk(
  "getDriverSuggestions",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/orders/${params.id}/driver-suggestions/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const markOrderAsLastOrder = createAsyncThunk(
  "markOrderAsLastOrder",
  async (params, { rejectWithValue }) => {
    const { id, ...networkParams } = params;
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/orders/${id}/mark-as-last-order/`,
        networkParams,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

// Pull one driver's current route (active stops in delivery_sequence order).
// Same `{ driver_id, orders, stops }` shape as the PUT below, so the map reuses
// normalizeRouteResponse/applyRouteResponse to resync a driver's sequences —
// e.g. after one of their orders completes and the backend renumbers the rest.
export const getDriverRoute = createAsyncThunk(
  "getDriverRoute",
  async ({ driverId }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/drivers/${driverId}/route/`,
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const updateDriverRoute = createAsyncThunk(
  "updateDriverRoute",
  async ({ driverId, orderSequence }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.put(
        `${config.API_URL_V2}/drivers/${driverId}/route/`,
        { order_sequence: orderSequence },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const exportOrders = createAsyncThunk(
  "exportOrders",
  async ({ format, ...params }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/orders/export/${format || 'xlsx'}/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
